import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
const _excluded = ["collapsedHeight", "children", "buttonCustomColor"];
import { animated, useSpring } from '@react-spring/web';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useToggle } from '../../hooks';
import { Collapse } from '../Collapse';
import { Icon } from '../Icon';
import { ChevronDown } from '../Icons';
import { Box } from '../Layout';
import { Text } from '../Typography';
const RotationBox = animated(Box);
export const SeeMore = _ref => {
  let {
      collapsedHeight,
      children,
      buttonCustomColor
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const ref = useRef();
  const [shouldExpand, setShouldExpand] = useState(true);
  const [isCollapsed, toggle] = useToggle(true);
  const style = useSpring({
    transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)'
  });
  useEffect(() => setShouldExpand(collapsedHeight < ref.current.scrollHeight), [children]);
  return React.createElement(Box, null, React.createElement(Collapse, _extends({
    ref: ref,
    isCollapsed: isCollapsed,
    collapsedHeight: collapsedHeight
  }, rest), React.createElement(_StyledText, _extends({
    textAlign: "justify",
    onClick: toggle
  }, rest), children)), shouldExpand && React.createElement(RotationBox, {
    mt: 2,
    mb: 3,
    style: style,
    width: "min-content"
  }, React.createElement(Icon, {
    color: buttonCustomColor,
    fontSize: 6,
    onClick: toggle,
    isPointer: true
  }, React.createElement(ChevronDown, null))));
};
SeeMore.defaultProps = {
  collapsedHeight: 96,
  buttonCustomColor: ''
};
SeeMore.propTypes = process.env.NODE_ENV !== "production" ? {
  collapsedHeight: PropTypes.number,
  buttonCustomColor: PropTypes.string,
  children: PropTypes.string.isRequired
} : {};
var _StyledText = _styled(Text).withConfig({
  displayName: "_StyledText",
  componentId: "sc-u51p6h-0"
})(["white-space:pre-line;"]);